// // import React from 'react';
// // import { Link } from 'react-router-dom';
// // import { mockStores } from '../mock';

// // const Footer = () => {
// //   const instagramImages = [
// //     "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1519869325930-281384150729?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=150&h=150&fit=crop",
// //     "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=150&h=150&fit=crop"
// //   ];

// //   return (
// //     <footer className="bg-white">
// //       {/* Instagram Section */}
// //       <div className="py-12">
// //         <div className="max-w-7xl mx-auto px-4">
// //           <h3 className="text-2xl font-semibold text-center mb-8 text-gray-800">
// //             Follow us on Instagram
// //           </h3>
// //           <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
// //             {instagramImages.map((image, index) => (
// //               <div key={index} className="aspect-square overflow-hidden rounded-lg hover:opacity-80 transition-opacity cursor-pointer">
// //                 <img
// //                   src={image}
// //                   alt={`Instagram post ${index + 1}`}
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* Footer Content */}
// //       <div className="bg-gray-50 py-12">
// //         <div className="max-w-7xl mx-auto px-4">
// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
// //             {/* Quick Links */}
// //             <div>
// //               <h4 className="font-semibold text-gray-800 mb-4">Quick Links</h4>
// //               <ul className="space-y-2 text-sm text-gray-600">
// //                 <li><Link to="/" className="hover:text-pink-400 transition-colors">Terms & Conditions</Link></li>
// //                 <li><Link to="/" className="hover:text-pink-400 transition-colors">Privacy Policy</Link></li>
// //                 <li><Link to="/" className="hover:text-pink-400 transition-colors">Shipping Policy</Link></li>
// //                 <li><Link to="/" className="hover:text-pink-400 transition-colors">Refund Policy</Link></li>
// //                 <li><Link to="/blog" className="hover:text-pink-400 transition-colors">Blog</Link></li>
// //               </ul>
// //             </div>

// //             {/* Main Menu */}
// //             <div>
// //               <h4 className="font-semibold text-gray-800 mb-4">Main menu</h4>
// //               <ul className="space-y-2 text-sm text-gray-600">
// //                 <li><Link to="/" className="hover:text-pink-400 transition-colors">Home</Link></li>
// //                 <li><Link to="/about" className="hover:text-pink-400 transition-colors">About Us</Link></li>
// //                 <li><Link to="/products" className="hover:text-pink-400 transition-colors">Order Now</Link></li>
// //                 <li><Link to="/contact" className="hover:text-pink-400 transition-colors">Contact Us</Link></li>
// //                 <li><Link to="/blog" className="hover:text-pink-400 transition-colors">Blog</Link></li>
// //               </ul>
// //             </div>

// //             {/* Bakelore */}
// //             <div>
// //               <h4 className="font-semibold text-gray-800 mb-4">Bakelore</h4>
// //               <div className="text-sm text-gray-600 space-y-2">
// //                 <p><strong>Contact:</strong> +91 799 799 0122</p>
// //                 <p>Mail: hello@bakelore.com</p>
// //               </div>
// //               <h5 className="font-medium text-gray-800 mt-4 mb-2">Our Recent Blogs</h5>
// //               <div className="flex gap-2">
// //                 {instagramImages.slice(0, 4).map((image, index) => (
// //                   <div key={index} className="w-12 h-12 rounded overflow-hidden">
// //                     <img src={image} alt={`Blog ${index + 1}`} className="w-full h-full object-cover" />
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>

// //             {/* Our Menu */}
// //             <div>
// //               <h4 className="font-semibold text-gray-800 mb-4">Our Menu</h4>
// //               <ul className="space-y-2 text-sm text-gray-600">
// //                 <li><Link to="/products?category=cakes" className="hover:text-pink-400 transition-colors">Cakes</Link></li>
// //                 <li><Link to="/products?category=desserts" className="hover:text-pink-400 transition-colors">Desserts</Link></li>
// //                 <li><Link to="/products?category=food" className="hover:text-pink-400 transition-colors">Food & Beverages</Link></li>
// //                 <li><Link to="/products?category=breakfast" className="hover:text-pink-400 transition-colors">All Day Breakfast</Link></li>
// //                 <li><Link to="/products?category=hampers" className="hover:text-pink-400 transition-colors">Hampers</Link></li>
// //               </ul>
// //             </div>

// //             {/* Best Selling */}
// //             <div>
// //               <h4 className="font-semibold text-gray-800 mb-4">Best Selling</h4>
// //               <ul className="space-y-2 text-sm text-gray-600">
// //                 <li><Link to="/products" className="hover:text-pink-400 transition-colors">Pizzas</Link></li>
// //                 <li><Link to="/products" className="hover:text-pink-400 transition-colors">Cakes</Link></li>
// //                 <li><Link to="/products" className="hover:text-pink-400 transition-colors">Hamburgers</Link></li>
// //                 <li><Link to="/products" className="hover:text-pink-400 transition-colors">Burgers</Link></li>
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Bottom Bar */}
// //       <div className="bg-gray-100 py-4">
// //         <div className="max-w-7xl mx-auto px-4 text-center text-sm text-gray-600">
// //           © 2025 All Rights Reserved | Designed and Maintained by SKYFIT MEDIA
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// import React from "react";
// import { FaWhatsapp } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="bg-[#f8f6f1] text-[#333] py-10 px-6 md:px-16 border-t border-gray-200">
//       <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 mb-10">
//         {/* Quick Links */}
//         <div>
//           <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
//           <ul className="space-y-2 text-gray-700">
//             <li>Terms & Conditions</li>
//             <li>Privacy Policy</li>
//             <li>Shipping Policy</li>
//             <li>Return Policy</li>
//             <li>Blog</li>
//           </ul>
//         </div>

//         {/* Main Menu */}
//         <div>
//           <h3 className="text-lg font-semibold mb-4">Main menu</h3>
//           <ul className="space-y-2 text-gray-700">
//             <li>Home</li>
//             <li>About us</li>
//             <li>Order Now</li>
//             <li>Diwali Offers</li>
//             <li>Contact Us</li>
//             <li>Blog</li>
//           </ul>
//         </div>

//         {/* Center Contact Info */}
//         <div className="col-span-2 md:col-span-1 flex flex-col items-center text-center">
//           <img
//             src="http://bakelore.com/images/bakelore-logo"
//             alt="Bakelore Logo"
//             className="h-8 mb-4"
//           />
//           <p className="text-gray-700">
//             <span className="font-semibold">Contact:</span> +91 799 799 0122
//           </p>
//           <p className="text-gray-700">
//             <span className="font-semibold">Mail:</span> hello@bakelore.com
//           </p>

//           <h3 className="text-lg font-semibold mt-6 mb-3">Our Recent Blogs</h3>
//           <div className="flex space-x-3">
//             <img
//               src="http://bakelore.com/images/Eggless-Belgium-Cake-Bakelore.jpg"
//               alt="blog"
//               className="h-24 w-24 object-cover rounded"
//             />
//             <img
//               src="http://bakelore.com/images/Eggless-Rasmalai-Cake-Bakelore.jpg"
//               alt="blog"
//               className="h-24 w-24 object-cover rounded"
//             />
//             <img
//               src="http://bakelore.com/images/koreangarlicbun_3_11zon.jpg"
//               alt="blog"
//               className="h-24 w-24 object-cover rounded"
//             />
//             <img
//               src="http://bakelore.com/images/dutch-choclate-dream-cake-bakelore.jpg"
//               alt="blog"
//               className="h-24 w-24 object-cover rounded"
//             />
//           </div>
//         </div>

//         {/* Our Menu */}
//         <div>
//           <h3 className="text-lg font-semibold mb-4">Our Menu</h3>
//           <ul className="space-y-2 text-gray-700">
//             <li>Cakes</li>
//             <li>Desserts</li>
//             <li>Food & Savories</li>
//             <li>All Day Breakfast</li>
//             <li>Hampers</li>
//           </ul>
//         </div>

//         {/* Best Selling */}
//         <div>
//           <h3 className="text-lg font-semibold mb-4">Best Selling</h3>
//           <ul className="space-y-2 text-gray-700">
//             <li>Pizza</li>
//             <li>Cakes</li>
//             <li>Hampers</li>
//             <li>Beverages</li>
//             <li>Burgers</li>
//           </ul>
//         </div>
//       </div>

//       {/* Bottom Section */}
//       <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-center items-center text-gray-600 text-sm gap-2">
//         <p className="flex items-center">
//           © 2025 All Rights Reserved | Designed and Maintained by{" "}
//           <span className="font-semibold text-[#a6746a] ml-1">SKYHIT MEDIA</span>
//         </p>
//       </div>

//       {/* WhatsApp Button */}
//       <div className="fixed bottom-5 right-5 bg-green-500 text-white p-3 rounded-full shadow-lg cursor-pointer hover:bg-green-600 transition">
//         <FaWhatsapp size={24} />
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// import React from "react";
// import { FaWhatsapp } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="bg-[#f8f6f1] text-[#333] py-12 px-6 md:px-16 border-t border-gray-200">
//       <div className="max-w-7xl mx-auto">
//         {/* Top Footer Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
//           {/* Quick Links */}
//           <div>
//             <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
//             <ul className="space-y-2 text-gray-700">
//               <li>Terms & Conditions</li>
//               <li>Privacy Policy</li>
//               <li>Shipping Policy</li>
//               <li>Return Policy</li>
//               <li>Blog</li>
//             </ul>
//           </div>

//           {/* Main Menu */}
//           <div>
//             <h3 className="text-lg font-semibold mb-4">Main Menu</h3>
//             <ul className="space-y-2 text-gray-700">
//               <li>Home</li>
//               <li>About Us</li>
//               <li>Order Now</li>
//               <li>Diwali Offers</li>
//               <li>Contact Us</li>
//               <li>Blog</li>
//             </ul>
//           </div>

//           {/* Center Contact Info */}
//           <div className="text-center flex flex-col items-center">
//             <img
//               src="http://bakelore.com/images/bakelore-logo"
//               alt="Bakelore Logo"
//               className="h-10 mb-4"
//             />
//             <p className="text-gray-700 text-sm md:text-base">
//               <span className="font-semibold">Contact:</span> +91 799 799 0122
//             </p>
//             <p className="text-gray-700 text-sm md:text-base">
//               <span className="font-semibold">Mail:</span> hello@bakelore.com
//             </p>

//             <h3 className="text-lg font-semibold mt-6 mb-3">Our Recent Blogs</h3>
//             <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 justify-items-center">
//               {[
//                 "http://bakelore.com/images/Eggless-Belgium-Cake-Bakelore.jpg",
//                 "http://bakelore.com/images/Eggless-Rasmalai-Cake-Bakelore.jpg",
//                 "http://bakelore.com/images/koreangarlicbun_3_11zon.jpg",
//                 "http://bakelore.com/images/dutch-choclate-dream-cake-bakelore.jpg",
//               ].map((img, i) => (
//                 <img
//                   key={i}
//                   src={img}
//                   alt={`blog-${i}`}
//                   className="h-20 w-20 object-cover rounded-md shadow-sm hover:scale-105 transition-transform duration-300"
//                 />
//               ))}
//             </div>
//           </div>

//           {/* Our Menu */}
//           <div>
//             <h3 className="text-lg font-semibold mb-4">Our Menu</h3>
//             <ul className="space-y-2 text-gray-700">
//               <li>Cakes</li>
//               <li>Desserts</li>
//               <li>Food & Savories</li>
//               <li>All Day Breakfast</li>
//               <li>Hampers</li>
//             </ul>
//           </div>

//           {/* Best Selling */}
//           <div>
//             <h3 className="text-lg font-semibold mb-4">Best Selling</h3>
//             <ul className="space-y-2 text-gray-700">
//               <li>Pizza</li>
//               <li>Cakes</li>
//               <li>Hampers</li>
//               <li>Beverages</li>
//               <li>Burgers</li>
//             </ul>
//           </div>
//         </div>

//         {/* Bottom Section */}
//         <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-center items-center text-gray-600 text-sm gap-2 text-center">
//           <p>
//             © 2025 All Rights Reserved | Designed and Maintained by{" "}
//             <span className="font-semibold text-[#a6746a]">SKYHIT MEDIA</span>
//           </p>
//         </div>
//       </div>

//       {/* Floating WhatsApp Button */}
//       <a
//         href="https://wa.me/917997990122"
//         target="_blank"
//         rel="noopener noreferrer"
//         className="fixed bottom-5 right-5 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition"
//       >
//         <FaWhatsapp size={26} />
//       </a>
//     </footer>
//   );
// };

// export default Footer;

// import React from "react";
// import { FaWhatsapp } from "react-icons/fa";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   return (
//     <footer className="bg-[#f8f6f1] text-[#333] py-12 px-6 md:px-16 border-t border-gray-200">
//       <div className="max-w-7xl mx-auto">
//         {/* Top Footer Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12 text-center sm:text-left">
//           {/* Quick Links */}
//           <div>
//             <h3
//               className="text-lg font-semibold mb-4"
//               style={{ fontFamily: "Philosopher", serif" }}
//             >
//               Quick Links
//             </h3>
//             <ul
//               className="space-y-2 text-gray-700"
//               style={{ fontFamily: "Manrope, sans-serif" }}
//             >
//               <li>Terms & Conditions</li>
//               <li>Privacy Policy</li>
//               <li>Shipping Policy</li>
//               <li>Return Policy</li>
//             </ul>
//           </div>

//           {/* Main Menu */}
//           <div>
//             <h3
//               className="text-lg font-semibold mb-4"
//               style={{ fontFamily: "Philosopher", serif" }}
//             >
//               Main Menu
//             </h3>
//             <ul
//               className="space-y-2 text-gray-700"
//               style={{ fontFamily: "Manrope, sans-serif" }}
//             >
//               <li>
//                 <Link to="/" className="hover:text-gray-900 transition">
//                   Home
//                 </Link>
//               </li>

//               <li>
//                 <Link to="/about" className="hover:text-gray-900 transition">
//                   About Us
//                 </Link>
//               </li>

//               <li>
//                 <Link to="/contact" className="hover:text-gray-900 transition">
//                   Contact Us
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* Center Contact Info */}
//           <div className="flex flex-col items-center">
//             <img
//               src="http://bakelore.com/images/bakelore-logo"
//               alt="Bakelore Logo"
//               className="h-10 mb-4"
//             />
//             <p
//               className="text-gray-700 text-sm md:text-base"
//               style={{ fontFamily: "Manrope, sans-serif" }}
//             >
//               <span className="font-semibold">Contact:</span> +91 799 799 0122
//             </p>
//             <p
//               className="text-gray-700 text-sm md:text-base"
//               style={{ fontFamily: "Manrope, sans-serif" }}
//             >
//               <span className="font-semibold">Mail:</span> hello@bakelore.com
//             </p>

//             <h3
//               className="text-lg font-semibold mt-6 mb-3"
//               style={{ fontFamily: "Philosopher", serif" }}
//             >
//               Our Recent Blogs
//             </h3>
//             <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 justify-items-center">
//               {[
//                 "http://bakelore.com/images/Eggless-Belgium-Cake-Bakelore.jpg",
//                 "http://bakelore.com/images/Eggless-Rasmalai-Cake-Bakelore.jpg",
//                 "http://bakelore.com/images/koreangarlicbun_3_11zon.jpg",
//                 "http://bakelore.com/images/dutch-choclate-dream-cake-bakelore.jpg",
//               ].map((img, i) => (
//                 <img
//                   key={i}
//                   src={img}
//                   alt={`blog-${i}`}
//                   className="h-20 w-20 object-cover rounded-md shadow-sm hover:scale-105 transition-transform duration-300"
//                 />
//               ))}
//             </div>
//           </div>

//           {/* Our Menu */}
//           <div>
//             <h3
//               className="text-lg font-semibold mb-4"
//               style={{ fontFamily: "Philosopher", serif" }}
//             >
//               Our Menu
//             </h3>
//             <ul
//               className="space-y-2 text-gray-700"
//               style={{ fontFamily: "Manrope, sans-serif" }}
//             >
//               <li>Cakes</li>
//               <li>Desserts</li>
//               <li>Food & Savories</li>
//               <li>All Day Breakfast</li>
//               <li>Hampers</li>
//             </ul>
//           </div>

//           {/* Best Selling */}
//           <div>
//             <h3
//               className="text-lg font-semibold mb-4"
//               style={{ fontFamily: "Philosopher", serif" }}
//             >
//               Best Selling
//             </h3>
//             <ul
//               className="space-y-2 text-gray-700"
//               style={{ fontFamily: "Manrope, sans-serif" }}
//             >
//               <li>Pizza</li>
//               <li>Cakes</li>
//               <li>Hampers</li>
//               <li>Beverages</li>
//               <li>Burgers</li>
//             </ul>
//           </div>
//         </div>

//         {/* Bottom Section */}
//         <div
//           className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-center items-center text-gray-600 text-sm gap-2 text-center"
//           style={{ fontFamily: "Manrope, sans-serif" }}
//         >
//           <p>
//             © 2025 All Rights Reserved | Designed and Maintained by{" "}
//             <a
//               href="https://skyhitmedia.com/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="font-semibold text-[#a6746a] hover:underline"
//             >
//               SKYHIT MEDIA
//             </a>
//           </p>
//         </div>
//       </div>

//       {/* Floating WhatsApp Button */}
//       <a
//         href="https://wa.me/917997990122"
//         target="_blank"
//         rel="noopener noreferrer"
//         className="fixed bottom-5 right-5 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition"
//       >
//         <FaWhatsapp size={26} />
//       </a>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#f8f6f1] text-[#333] py-12 px-6 md:px-16 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        {/* Top Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12 text-center sm:text-left">

          {/* Quick Links */}
          <div>
            <h3
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "Philosopher, serif" }}
            >
              Quick Links
            </h3>
            <ul
              className="space-y-2 text-gray-700"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
<li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
<li><Link to="/shipping-policy">Shipping Policy</Link></li>
              <li><Link to="/return-policy">Return Policy</Link></li>
            </ul>
          </div>  

          {/* Main Menu */}
          <div>
            <h3
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "Philosopher, serif" }}
            >
              Main Menu
            </h3>
            <ul
              className="space-y-2 text-gray-700"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Center Contact Info */}
          <div className="flex flex-col items-center">
            <img
              src="http://bakelore.com/images/bakelore-logo"
              alt="Bakelore Logo"
              className="h-10 mb-4"
            />

            {/* Phone link */}
            <p className="text-gray-700 text-sm md:text-base" style={{ fontFamily: "Manrope, sans-serif" }}>
              <span className="font-semibold">Contact:</span>
              <a href="tel:+918121034991" className="ml-1 hover:underline">
                +91 8121034991
              </a>
            </p>


            {/* Email link */}
            <p className="text-gray-700 text-sm md:text-base" style={{ fontFamily: "Manrope, sans-serif" }}>
              <span className="font-semibold">Mail:</span>
              <a href="mailto:hello@bakelore.com" className="ml-1 hover:underline">
                hello@bakelore.com
              </a>
            </p>

            <h3
              className="text-lg font-semibold mt-6 mb-3"
              style={{ fontFamily: "Philosopher, serif" }}
            >
              Our Recent Blogs
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 justify-items-center">
              {[
                "http://bakelore.com/images/Eggless-Belgium-Cake-Bakelore.jpg",
                "http://bakelore.com/images/Eggless-Rasmalai-Cake-Bakelore.jpg",
                "http://bakelore.com/images/koreangarlicbun_3_11zon.jpg",
                "http://bakelore.com/images/dutch-choclate-dream-cake-bakelore.jpg",
              ].map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`blog-${i}`}
                  className="h-20 w-20 object-cover rounded-md shadow-sm hover:scale-105 transition-transform duration-300"
                />
              ))}
            </div>
          </div>

          {/* Our Menu */}
          <div>
            <h3
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "Philosopher, serif" }}
            >
              Our Menu
            </h3>
            <ul
              className="space-y-2 text-gray-700"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              <li><Link to="#">Cakes</Link></li>
              <li><Link to="#">Desserts</Link></li>
              <li><Link to="#">Food & Savories</Link></li>
              <li><Link to="#">All Day Breakfast</Link></li>
              <li><Link to="#">Hampers</Link></li>
              <li><Link to="#">Sides</Link></li>
            </ul>
          </div>

          {/* Best Selling */}
          <div>
            <h3
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "Philosopher, serif" }}
            >
              Best Selling
            </h3>
            <ul
              className="space-y-2 text-gray-700"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              <li><Link to="#">Pizza</Link></li>
              <li><Link to="#">Cakes</Link></li>
              <li><Link to="#">Hampers</Link></li>
              <li><Link to="#">Beverages</Link></li>
              <li><Link to="#">Burgers</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div
          className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-center items-center text-gray-600 text-sm gap-2 text-center"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          <p>
            © 2025 All Rights Reserved | Designed and Maintained by{" "}
            <a
              href="https://skyhitmedia.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#C08B89] hover:underline"
            >
              SKYHIT MEDIA
            </a>
          </p>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition"
      >
        <FaWhatsapp size={26} />
      </a>
    </footer>
  );
};

export default Footer;
